import React, {lazy, Suspense} from 'react'

const Editor = lazy(() => import('./Editor'))

export default function EditorField(props) {
  return (
    <Suspense fallback={null}>
      <Editor {...props} />
    </Suspense>
  )
}
